export default __webpack_public_path__ + "static/media/xubi.f1953bda.png";